import React, { useEffect, useMemo } from 'react';
import {
  Datagrid,
  TextField,
  useUnselectAll,
  ReferenceField,
  linkToRecord
} from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import StatusSelectField from '../../../core/components/StatusSelectField';
import { investorStatus } from '../../investors/InvestorLookups';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  table: {
    '& tbody>.MuiTableRow-root:hover': {
      background: 'unset',
      cursor: 'default'
    }
  },
  statusColumnStyle: {
    width: '68px'
  },
  label: {
    color: '#424242',
    fontSize: '14px',
    display: 'inline-block',
    paddingBottom: '10px'
  },
  expandLabel: {
    color: '#757575',
    fontSize: '14px',
    display: 'inline-block',
    transform: 'translateY(-10px)'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  editButton: {
    color: '#757575',
    minWidth: '24px',
    padding: '6px 0',
    '& span': {
      paddingRight: 0
    }
  },
  editButtonColumnStyle: {
    width: '24px'
  }
});

const OrganizationInvestorDatagrid = props => {
  const {
    handleRowClick,
    classes,
    expand,
    permissions,
    hasList,
    userProfile,
    hasShow,
    hasEdit,
    ...datagridProps
  } = props;

  //unselecting all the checkboxes from the deleting actions in the ComponenWillUnmount listener
  const unSelectAll = useUnselectAll(datagridProps.resource);

  useEffect(() => () => unSelectAll(), [unSelectAll]);

  const hasReadInvestorPermission = useMemo(() => {
    return permissions.includes('AUTH_READ_INVESTOR_NA');
  }, [permissions]);

  if (props.total > 0) {
    return (
      <>
        {expand && <span className={classes.label}>Related Investors</span>}
        <Datagrid {...datagridProps} className={classes.table}>
          <ReferenceField
            source="id"
            reference="investors"
            label="Investor Name"
            link={(record, reference) =>
              hasReadInvestorPermission
                ? `${linkToRecord(`/${reference}`, record.id)}`
                : false
            }
            sortBy="name"
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField label="A.K.A." source="aka" sortable={false} />
          <TextField source="id" label="Investor ID" sortable={false} />
          <StatusSelectField
            label="Status"
            source="status"
            choices={investorStatus}
            headerClassName={classes.statusColumnStyle}
            cellClassName={classes.statusColumnStyle}
            sortable={false}
          />
        </Datagrid>
      </>
    );
  } else if (props.loaded) {
    return (
      <span className={expand ? classes.expandLabel : classes.label}>
        There are no related Investors to be displayed
      </span>
    );
  } else {
    return (
      <div className={classes.progress}>
        <CircularProgress />
      </div>
    );
  }
};

export default withStyles(styles)(OrganizationInvestorDatagrid);
